import { accountConflictError } from './account-conflict';

const SUPPORT_HINT = 'Se o problema persistir, entre em contato com nossa equipe de suporte.';

export interface AccountCreationError {
  code?: string;
  errorMessages?: string[];
}

/** Título e descrição para a recusa do backend ao criar uma conta. */
export function accountCreationError(error?: AccountCreationError): { message: string; description: string } {
  if (error?.code === 'accountCreationExpired') {
    return {
      message: 'O tempo para criar a conta acabou.',
      description: 'Entre com o gov.br novamente para continuar.',
    };
  }

  return (
    accountConflictError(error) ?? {
      message: 'Não foi possível criar a conta.',
      description: SUPPORT_HINT,
    }
  );
}
